import {RequestEntity} from "../../../../types/RequestEntity";
import {isSingleRequest} from "../../../../lib/isSingleRequest";
import Tooltiper from "components/Tooltiper";
import {isCombinedRequest} from "../../../../lib/isCombinedRequest";
import React from "react";

// Компонент рендеринга ячейки для вида спорта
export const SportKindNameCellRenderer = React.memo(function SportKindNameCellRenderer({equipmentRequestEntity}: { equipmentRequestEntity: RequestEntity }) {
    return (
        <>
            {isSingleRequest(equipmentRequestEntity) &&
                <Tooltiper text={equipmentRequestEntity?.sportKindObject?.name}/>
            }
            {isCombinedRequest(equipmentRequestEntity) &&
                <Tooltiper
                    text={
                        Array.from(new Set(equipmentRequestEntity?.childRequests
                            ?.map((request) => request.sportKindObject?.name)
                            .filter(name => name)
                        )).join(', ')
                    }
                />}
        </>
    );
}, (prevProps, nextProps) => {
    const prev = prevProps.equipmentRequestEntity;
    const next = nextProps.equipmentRequestEntity;
    
    if (isSingleRequest(prev) && isSingleRequest(next)) {
        return (
            prev.id === next.id &&
            prev.sportKindObject?.id === next.sportKindObject?.id &&
            prev.sportKindObject?.name === next.sportKindObject?.name
        );
    }
    
    if (isCombinedRequest(prev) && isCombinedRequest(next)) {
        const prevNames = Array.from(new Set(prev.childRequests?.map(r => r.sportKindObject?.name).filter(Boolean) || [])).sort().join(', ');
        const nextNames = Array.from(new Set(next.childRequests?.map(r => r.sportKindObject?.name).filter(Boolean) || [])).sort().join(', ');
        return prev.id === next.id && prevNames === nextNames;
    }
    
    return false;
});